import { createContext } from "react";

export const InstallPromptContext = createContext({
  deferredPrompt: null,
  setDeferredPrompt: () => {},
  showInstallUI: false,
  setShowInstallUI: () => {},
  dismiss: () => {},
});
